/**
 * Valid success response
 * @param response
 * @return boolean
 */
const isSuccessResponse = (response) =>
(response && Object.hasOwnProperty.call(response, 'data') && Object.hasOwnProperty.call(response.data, 'success') && response.data.success === true);

export default isSuccessResponse
